import React, { Component } from 'react';

export default class TargetsViewCentral extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {
            mode: 'neutral',
            isCalendarEdit: false
        }

        this.handleScroll = this.handleScroll.bind(this);

        this.changeMode = this.changeMode.bind(this);
        this.toggleCalendarEdit = this.toggleCalendarEdit.bind(this);

        this.getCardInner = this.getCardInner.bind(this);
        this.getCardHeaders = this.getCardHeaders.bind(this);
        this.getCalendarHeaders = this.getCalendarHeaders.bind(this);
        this.getKpiList = this.getKpiList.bind(this);
        this.getLocationList = this.getLocationList.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    handleScroll(e) {
        this.props.handleScrollTop(e.target.scrollTop <= 0, e.target.scrollTop);
    }

    changeMode(mode) {
        let self = this;
        this.setState({ mode: mode }, () => {
            self.props.handleDrillTarget(null, true);
        });
    }

    toggleCalendarEdit() {
        this.setState({ isCalendarEdit: !this.state.isCalendarEdit })
    }

    getCardInner() {
        let cardInnerJsx = [(
            <div className={"settings-central-regular-card-label"}>Targets</div>
        ), (
            <div className={"material-icons settings-central-topright-button" + (this.state.isCalendarEdit ? '' : ' disabled')} onClick={this.toggleCalendarEdit}>{"equalizer"}</div>
        ), (
            <div className={"material-icons settings-central-topright-button" + (this.state.isCalendarEdit ? ' disabled' : '')} onClick={this.toggleCalendarEdit}>{"date_range"}</div>
        )];

        if (!this.state.isCalendarEdit) {
            let headersJsx = this.getCardHeaders();
            headersJsx.forEach(header => {
                cardInnerJsx.push(header);
            });
        } else {
            let calendarJsx = this.getCalendarHeaders();
            calendarJsx.forEach(calendar => {
                cardInnerJsx.push(calendar);
            });
        }

        return cardInnerJsx;
    }

    getCardHeaders() {
        let headersJsx = [];

        let targets = this.props.targets;

        let isNew = false;
        if (targets.generalTarget === null) {
            isNew = true;
        }
        headersJsx.push((
            <div className={"settings-card-item-target-outer"} key={"general-progress"}>
                <div className={"title"}>{"General Progress"}</div>
                <div className={"button-space"}>
                    <div className={"percent-box"} onClick={this.props.handleSelectTarget.bind(null, (isNew ? "newGen" : targets.generalTarget)).bind(null, "percentDelta")}>
                        {isNew ? 0 : targets.generalTarget.percentDelta}
                    </div>
                    <div className={"percent-symbol"}>{"%"}</div>
                </div>
            </div>
        ));

        let locKpiAddon = ' neutral';
        let empKpiAddon = ' neutral';
        if (this.state.mode === 'locationKpi') {
            locKpiAddon = ' active';
            empKpiAddon = ' inactive';
        } else if (this.state.mode === 'employeeKpi') {
            locKpiAddon = ' inactive';
            empKpiAddon = ' active';
        }

        headersJsx.push((
            <div className={"settings-card-item-target-outer" + (isNew ? ' disabled' : '')} key={"kpi-mode-selector"}>
                <div className={"material-icons kpi-selector location" + locKpiAddon}
                    onClick={this.changeMode.bind(null, (this.state.mode === 'locationKpi' ? 'neutral' : 'locationKpi'))}>{"store_mall_directory"}</div>
                <div className={"material-icons kpi-selector employee" + empKpiAddon}
                    onClick={this.changeMode.bind(null, (this.state.mode === 'employeeKpi' ? 'neutral' : 'employeeKpi'))}>{"person"}</div>
            </div>
        ));

        if (this.props.activeTargetKpi === null) {
            headersJsx.push(this.getKpiList());
            headersJsx.push(<div className={"settings-card-item-kpi-container disabled"}></div>);
        } else {
            headersJsx.push((
                <div className={"settings-card-item-kpi-container"} style={{ height: '4rem' }}>
                    <div key={this.props.activeTargetKpi.reportKpiId} className={"settings-card-item-target-outer abpos"} style={{ top: '0rem' }}>
                        <div className={"title cover"} onClick={this.props.handleDrillTarget.bind(null, null).bind(null, false)}>{this.props.activeTargetKpi.name}</div>
                    </div>
                </div>
            ));

            headersJsx.push(this.getLocationList());
        }


        return headersJsx;
    }

    getCalendarHeaders() {
        let resJsx = [];

        let locationList = this.props.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations;
        let self = this;

        resJsx.push((
            <div className={"settings-central-regular-card-label-description"}>{"Number of days open in an average week"}</div>
        ));

        resJsx.push((
            <div className={"settings-card-item-target-calendar-outer"} key={"cal-default"} style={{ height: '6.6rem' }}>
                <div className={"calendar-label"}>{"All Locations"}</div>
                <div className={"calendar-days-outer"}>
                    {
                        (() => {
                            let r = [];
                            for (var i = 1; i <= 7; i++) {
                                r.push((<div className={"calendar-day active"}
                                    onClick={self.props.selectTargetCalendarDayAll.bind(null, i)}>{i}</div>));
                            }
                            return r;
                        })()
                    }
                </div>
            </div>
        ));

        locationList.forEach(location => {
            let activeDaysOpen = this.props.targets.locationToDaysInWeek[location.locationID];
            resJsx.push((
                <div className={"settings-card-item-target-calendar-outer"} key={"cal-" + location.name}>
                    <div className={"calendar-label"}>{location.name}</div>
                    <div className={"calendar-days-outer"}>
                        {
                            (() => {
                                let r = [];
                                for (var i = 1; i <= 7; i++) {
                                    r.push((<div className={"calendar-day" + (i === activeDaysOpen ? ' active' : '')}
                                        onClick={self.props.selectTargetCalendarDay.bind(null, location.locationID).bind(null, i)}>{i}</div>));
                                }
                                return r;
                            })()
                        }
                    </div>
                </div>
            ));
        });


        return resJsx;
    }

    getKpiList() {

        if (this.state.mode === 'neutral') {
            return (<div className={"settings-card-item-kpi-container disabled"}></div>);
        } else if (this.state.mode === 'locationKpi' || this.state.mode === 'employeeKpi') {

            let resJsx = [];

            let targets = this.props.targets;

            let kpiType = this.state.mode === 'locationKpi' ? 'BLAST' : 'BLASTP';
            let allKpis = this.props.reportKPIs;
            let index = 0;
            allKpis.forEach((kpi) => {

                if (kpi.kpiType === kpiType) {

                    let yoList = this.state.mode === 'locationKpi' ? 'defaultLocationTargets' : 'defaultEmployeeTargets';

                    let yoTarget = targets[yoList]
                        .reduce((r, e) => { if (e.reportKpiId === kpi.reportKpiId) { return e } else { return r } }, null);

                    let isNew = yoTarget === null;

                    resJsx.push((
                        <div key={kpi.reportKpiId} className={"settings-card-item-target-outer abpos"} style={{ top: (index * 3) + 'rem' }}>
                            <div className={"title short"}
                                onClick={this.props.handleDrillTarget.bind(null, { where: (0 + (index * 3)), name: kpi.name, reportKpiId: kpi.reportKpiId, percentDelta: (isNew ? null : yoTarget.percentDelta), dailyMinMax: (isNew ? null : yoTarget.dailyMinMax) }).bind(null, false)}>{kpi.name}</div>
                            <div className={"button-space long"}>
                                <div className={"number-box"}
                                    onClick={this.props.handleSelectTarget.bind(null, (isNew ? { reportKpiId: kpi.reportKpiId, isNew: true, list: yoList } : yoTarget)).bind(null, "dailyMinMax")}>
                                    {isNew ? "0" : yoTarget.dailyMinMax}
                                </div>
                                <div className={"number-symbol"}>{"#"}</div>
                                <div className={"percent-box"}
                                    onClick={this.props.handleSelectTarget.bind(null, (isNew ? { reportKpiId: kpi.reportKpiId, isNew: true, list: yoList } : yoTarget)).bind(null, "percentDelta")}>
                                    {isNew ? targets.generalTarget.percentDelta : yoTarget.percentDelta}
                                </div>
                                <div className={"percent-symbol"}>{"%"}</div>
                            </div>
                        </div>
                    ));

                    index++;
                }
            });

            return (<div className={"settings-card-item-kpi-container"} style={{ height: (resJsx.length * 3) + 'rem' }}>{resJsx}</div>);

        } else {
            return null;
        }
    }

    getLocationList() {
        let resJsx = [];

        let targets = this.props.targets;

        let activeKpi = this.props.activeTargetKpi;
        let locationList = this.props.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations;
        let index = 0;
        locationList.forEach((loc) => {


            let yoList = this.state.mode === 'locationKpi' ? 'locationTargets' : 'employeeTargets';

            let yoTarget = targets[yoList]
                .reduce((r, e) => { if (e.reportKpiId === activeKpi.reportKpiId && e.locationId === loc.locationID) { return e } else { return r } }, null);

            let isNew = yoTarget === null;

            resJsx.push((
                <div key={loc.locationID} className={"settings-card-item-target-outer abpos"} style={{ top: (index++ * 3) + 'rem' }}>
                    <div className={"title short"}>{loc.name}</div>
                    <div className={"button-space long"}>
                        <div className={"number-box"}
                            onClick={this.props.handleSelectTarget.bind(null, (isNew ? { locationId: loc.locationID, isNew: true, list: yoList } : yoTarget)).bind(null, "dailyMinMax")}>
                            {isNew ? activeKpi.dailyMinMax : yoTarget.dailyMinMax}
                        </div>
                        <div className={"number-symbol"}>{"#"}</div>
                        <div className={"percent-box"}
                            onClick={this.props.handleSelectTarget.bind(null, (isNew ? { locationId: loc.locationID, isNew: true, list: yoList } : yoTarget)).bind(null, "percentDelta")}>
                            {isNew ? activeKpi.percentDelta : yoTarget.percentDelta}
                        </div>
                        <div className={"percent-symbol"}>{"%"}</div>
                    </div>
                </div>
            ));
        });

        return (<div className={"settings-card-item-kpi-container"} style={{ height: (resJsx.length * 3) + 'rem' }}>{resJsx}</div>);
    }

    render() {

        let outerClass = "settings-sub-container scrollable";
        let outerStyle = this.props.style;

        let cardInnerJsx = this.getCardInner();

        return (
            <div className={outerClass} style={outerStyle} onScroll={this.handleScroll}>
                <div className={"settings-central-regular-card-container"}>
                    {cardInnerJsx}
                </div>
            </div>
        );
    }
}